// extracted by mini-css-extract-plugin
export default {"root":"CarAttributes-root","list":"CarAttributes-list","oneColumn":"CarAttributes-oneColumn","attributesModalTrigger":"CarAttributes-attributesModalTrigger"};